import React from 'react';
import './styles.scss';

import lempire from './assets/lempire.png';
import highlight from './assets/highlight.png';
import runn from './assets/runn.png';
import ecl from './assets/ecl.png';
import gouv from './assets/gouv.png';
import contra from './assets/contra.png';
import schoolyear from './assets/schoolyear.png';
import beatport from './assets/beatport.png';
import ionline from './assets/ionline.png';
import parseur from './assets/parseur.png';
import synaxon from './assets/synaxon.png';
import laddition from './assets/laddition.png';
import anyip from './assets/anyip.png';
import nuclei from './assets/nuclei.png';
import silverfort from './assets/silverfort.png';
import scrapingbee from './assets/scrapingbee.png';
import cleanshot from './assets/cleanshot.png';
import docstation from './assets/docstation.png';

const StatusPageExamples = () => (
  <div className="status-page-examples-container">
    <div className="mb-2em" />
    <div className="color-text flex width-fit-content padding-025em font-weight-400 font-size-14px border mb-05em" style={{background:'black',lineHeight:'20px',borderRadius:'20px',paddingLeft:'0.75em',paddingRight:'0.75em',marginLeft:'-1px'}}>Customer Showcase</div>
    <div className="font-weight-500 mb-05em" style={{ fontSize:'42px' }}>Meet our customers</div>
    <div className="color-text-secondary color-text-secondary flex line-height-15em font-weight-400 mb-2em" style={{fontSize:'22px'}}>
      Explore how leading companies use status pages to maintain transparency and build trust with their users through real-time system updates and incident communication.
    </div>

    <div className="flex flex-wrap gap-1em">
      {[
        { src: beatport, alt: "beatport", name: "Beatport.com", industry: "Music/Entertainment Tech", url: "https://status.beatport.com" },
        { src: runn, alt: "Runn", name: "Runn", industry: "Project Management", url: "https://status.runn.io" },
        { src: gouv, alt: "Gouv", name: "Gouv.fr", industry: "Government", url: "https://status.particulier.api.gouv.fr" },
        { src: highlight, alt: "Highlight", name: "Highlight.io", industry: "DevTools", url: "https://status.highlight.io" },
        { src: lempire, alt: "Lemlist", name: "Lemlist", industry: "Sales Tech", url: "https://status.lempire.com" },
        { src: contra, alt: "Contra", name: "Contra.com", industry: "HR Tech", url: "https://status.contra.com" },
        { src: ecl, alt: "ECL", name: "ecl-global.com", industry: "IT Services", url: "https://status.ecl-global.com" },
        { src: ionline, alt: "iONLINE", name: "iONLINE", industry: "ISP (Internet Service Provider)", url: "https://status.ionlinesp.com" },
        { src: schoolyear, alt: "schoolyear", name: "Schoolyear.com", industry: "EdTech", url: "https://status.schoolyear.com" },
        { src: parseur, alt: "parseur", name: "Parseur", industry: "Marketing Tech", url: "https://status.parseur.com" },
        { src: synaxon, alt: "synaxon", name: "Synaxon", industry: "IT Services", url: "https://status.synaxon.com" },
        { src: laddition, alt: "laddition", name: "L'addition", industry: "Food & Beverage", url: "https://status.laddition.com" },
        { src: anyip, alt: "anyip", name: "AnyIP", industry: "ISP (Internet Service Provider)", url: "https://status.anyip.io" },
        { src: nuclei, alt: "nuclei", name: "Nuclei", industry: "DevTools", url: "https://status.nuclei.ai" },
        { src: silverfort, alt: "silverfort", name: "Silverfort", industry: "Cybersecurity", url: "https://status.silverfort.com" },
        { src: scrapingbee, alt: "scrapingbee", name: "ScrapingBee", industry: "Web Scraping", url: "https://status.scrapingbee.com" },
        { src: cleanshot, alt: "cleanshot", name: "CleanShot", industry: "Productivity", url: "https://status.cleanshot.com" },
        { src: docstation, alt: "docstation", name: "DocStation", industry: "Productivity", url: "https://status.docstation.co" }
      ].map(({ src, alt, name, industry, url }) => (
        <a target="_blank" href={url} key={name} className="flex hoverable br-10px border padding-2em bg-moderate position-relative" style={{width: 'calc(33.33% - 0.67em)', height:'350px'}}>
          <img 
            className="br-10px border"
            src={src}
            alt={alt}
            style={{
              width:'100%',
              transition: 'transform 0.15s ease',
            }}
            onMouseEnter={e => e.target.style.transform = 'translateY(-10px)'}
            onMouseLeave={e => e.target.style.transform = 'translateY(0)'}
          />
          <div className="padding-1em bg-light border-top" style={{
            position: 'absolute',
            bottom: '0',
            left: '0',
            right: '0',
            borderRadius: '0 0 9px 9px',
          }}>
            <div className="font-weight-500 font-size-15px color-text" style={{marginBottom:'0.35em'}}>{name}</div>
            <div className="font-size-13px color-text-secondary">{industry}</div>
          </div>
        </a>
      ))}
    </div>
  </div>
);

export default StatusPageExamples;
